<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            删除
          </el-button> -->

          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <el-button type="primary" class="btn primary" size="small" v-preventReClick
            @click="UpdateChargeState">处理</el-button>
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.chargeNo" @keyup.enter.native="queryChange"
              suffix-icon="el-icon-search" />
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column prop="operation" label="操作" fixed="right" width="160">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.state != 1" v-preventReClick @click="showRemarkDialog(scope.row)"
                  class="color-blue">添加备注</el-button>
                <el-button type="text" v-if="scope.row.state == 2" v-preventReClick @click="handleCharge(scope.row)"
                  class="margin-left20 color-blue">重新核销</el-button>
                <el-button type="text" v-if="scope.row.state === 1 && 
                  (scope.row.categoryName === '计费' || scope.row.categoryName === '门诊确费') && 
                  tableAcl.indexOf('Refund')!= -1"
                  v-preventReClick @click="handleRefunds(scope.row)"
                  class="color-blue">退费</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
      style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
      <template slot="empty">
        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
          <img src="../../../../assets/noData.png" width="240" height="240" />
          <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
          <div class="empty-rest" @click="reset">恢复默认</div>
        </div>
      </template>
      <el-table-column fixed :reserve-selection="true" type="selection" width="55" align="center"></el-table-column>
      <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
      <el-table-column prop="productName" width="100" label="产品名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="specName" width="100" label="规格/型号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="hisProjectNo" width="110" label="计费项目编号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="patientNo" width="115" label="住院号/门诊号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="patientName" width="80" label="患者名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="deptName" min-width="200"  show-overflow-tooltip label="执行科室"></el-table-column>
      <el-table-column prop="categoryName" width="80" label="计费类型"></el-table-column>
      <el-table-column prop="chargeNo" width="100" show-overflow-tooltip label="计费单号"></el-table-column>
      <el-table-column prop="number" width="50" label="数量"></el-table-column>
      <el-table-column prop="price" width="60" label="单价"></el-table-column>
      <el-table-column prop="unit" width="60" label="单位">
        <template slot-scope="scope">
          {{ scope.row.unit?scope.row.unit:'-' }}
        </template>
      </el-table-column>
      <el-table-column prop="amount" width="80" label="小计"></el-table-column>
      <el-table-column prop="isOutpatient" label="是否门诊" width="80" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.isOutpatient == 1 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="stateName" label="计费状态" show-overflow-tooltip></el-table-column>
      <el-table-column prop="failureNumber" label="失败次数" show-overflow-tooltip></el-table-column>
      <el-table-column prop="remark" width="120" label="备注" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.remark?scope.row.remark:'-' }}
        </template>
      </el-table-column>
      <el-table-column prop="sourceChargeNo" width="100" show-overflow-tooltip label="原计费单号">
        <template slot-scope="scope">
          {{ scope.row.sourceChargeNo?scope.row.sourceChargeNo:'-' }}
        </template>
      </el-table-column>
      <el-table-column prop="mainNo" width="80" label="主条码" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.mainNo?scope.row.mainNo:'-' }}
        </template>
      </el-table-column>
      <el-table-column prop="traceNo" width="80" label="溯源码" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.traceNo?scope.row.traceNo:'-' }}
        </template>
      </el-table-column>
      <el-table-column prop="batch" width="70" label="批号" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.batch?scope.row.batch:'-' }}
        </template>
      </el-table-column>
      <el-table-column prop="createdUserName" label="计费人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createdTime" min-width="170" label="计费时间">
        <template slot-scope="scope">
          {{ scope.row.createdTime?parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}"):'-' }}
        </template>
      </el-table-column>
      <el-table-column prop="receivedTime" min-width="170" label="接收时间">
        <template slot-scope="scope">
          {{ scope.row.receivedTime?parseTime(new Date(scope.row.receivedTime), "{y}-{m}-{d} {h}:{i}:{s}"):'-' }}
        </template>
      </el-table-column>
      <el-table-column prop="createdDeptName" width="90" label="计费科室" show-overflow-tooltip></el-table-column>
      <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
        width="200"></el-table-column>
      <el-table-column prop="operation" label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.state != 1" v-preventReClick @click="showRemarkDialog(scope.row)"
            class="color-blue">添加备注</el-button>
          <el-button type="text" v-if="scope.row.state == 2" v-preventReClick @click="handleCharge(scope.row)"
            class="margin-left20 color-blue">重新核销</el-button>
          <el-button type="text" v-if="scope.row.state === 1 && 
            (scope.row.categoryName === '计费' || scope.row.categoryName === '门诊确费') && 
            tableAcl.indexOf('Refund')!= -1"
            v-preventReClick @click="handleRefunds(scope.row)"
            class="color-blue">退费</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
    

      <!-- 编辑弹出框 -->
      <el-dialog title="添加备注" :visible.sync="remarkVisible" width="60%" :close-on-click-modal="false">
        <el-form ref="form" :model="form" label-width="70px">
          <el-row>
            <el-col>
              <el-form-item prop="remark" label="备注">
                <el-input v-model="form.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="remarkVisible = false">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="saveRemark">确
            定</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="title + route.menuName" :visible.sync="open" :center="true" width="1300px"
        :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form">
          <el-row>
            <el-col :span="6">
              <el-form-item prop="mainNo" label="主码">
                <el-input :disabled="!editMode" v-model="form.mainNo" placeholder="请输入主码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="traceNo" label="追溯码">
                <el-input :disabled="!editMode" v-model="form.traceNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="supplierProductName" label="供货商产品">
                <SelectTable :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'"
                  :innerName="form.supplierProductName" :dataList="STATIC_SupplierProducts"
                  @filterMethod="getProductList" @change="supplierProductChange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="patientNo" label="患者住院号">
                <el-input :disabled="!editMode" v-model="form.patientNo" placeholder="请输入患者住院号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="deptId" label="执行科室">




                <el-select v-if="system_setting.IsUseWard" v-model="form.deptName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptAndWards" @change="applyDeptChange1">
                  <el-option v-for="item in STATIC_DeptAndWards" :key="item.idGroup" :label="item.deptNo+' '+item.deptName +' '+(item.wardName?item.wardName:'')" :value="item.idGroup"></el-option>
                </el-select>

                <el-select v-else v-model="form.deptId" placeholder="请选择" :disabled="!editMode" filterable
                  :filter-method="getDepts" @change="deptChange" style="width: 100%">
                  <el-option key="0" label="请选择执行科室" value></el-option>
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no+' '+item.name"
                    :value="item.hisDeptId"></el-option>
                </el-select>

            
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="chargeNo" label="计费单号">
                <el-input :disabled="!editMode" v-model="form.chargeNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="sourceChargeNo" label="原计费单号">
                <el-input :disabled="!editMode" v-model="form.sourceChargeNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="category" label="类型">
                <el-radio-group :disabled="!editMode" v-model="form.category">
                  <el-radio v-for="item in ChargeCategoryOptions" :label="item.id" :key="item.id">{{ item.name
                    }}</el-radio>
                  <!-- <el-radio :label="0">计费</el-radio>
                  <el-radio :label="1">退费</el-radio> -->
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="number" label="数量">
                <el-input :disabled="!editMode" v-model="form.number" placeholder="请输入数量"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="price" label="单价">
                <el-input :disabled="!editMode" v-model="form.price" placeholder="请输入单价"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batch">
                <el-input :disabled="!editMode" v-model="form.batch"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否门诊" prop="isOutpatient">
                <el-radio-group :disabled="!editMode" v-model="form.isOutpatient">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="计费护士" prop="createdUser">
                <el-select :disabled="!editMode" v-model="form.createdUser" filterable :filter-method="getUsers"
                  placeholder="请选择计费护士" style="width: 100%">
                  <el-option key="0" label="请选择计费护士" value></el-option>
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.name"
                    :value="item.hisUserId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计费科室" prop="createdDept">



                <el-select v-if="system_setting.IsUseWard" v-model="form.chargeDeptName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptAndWards" @change="chargeDeptChange1">
                  <el-option v-for="item in STATIC_DeptAndWards" :key="item.idGroup" :label="item.deptNo+' '+item.deptName +' '+(item.wardName?item.wardName:'')" :value="item.idGroup"></el-option>
                </el-select>

                <el-select v-else v-model="form.createdDept" placeholder="请选择" :disabled="!editMode" filterable
                  :filter-method="getDepts" @change="chargeDeptChange" style="width: 100%">
                  <el-option key="0" label="请选择计费科室" value></el-option>
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no+' '+item.name"
                    :value="item.hisDeptId"></el-option>
                </el-select>


         
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetHisCharges,
  UpdateChargeState,
  GetHisChargePrintData,
  Charge,
  UpdateHisChargeRemark,
  SaveHisCharge,
  ExportHisCharges,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import SelectTree from '@/components/select-tree'
import { ChargeStateOptions, ChargeCategoryOptions,ChargeCategoryOptions1 } from "@/enum";
import SelectTable from "@/components/select-table";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    // SelectTree
    SelectTable,
    SelectFilter,
  },
  data () {
    return {
      exportAction: ExportHisCharges,
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      editMode: false,
      ChargeStateOptions: ChargeStateOptions,
      ChargeCategoryOptions: ChargeCategoryOptions,
      ChargeCategoryOptions1:ChargeCategoryOptions1,
      filterOptions: [
        {
          name: "产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "计费科室",
          type: "select",
          code: "hisDeptId",
          filterMethod: this.getDeptList,
          data: [],
        },
        {
          name: "执行科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDeptList,
          data: [],
        },
        {
        name: "计费类型",
        type: "select",
        code: "Categorys",
        data: ChargeCategoryOptions1,
        multiple:true
      },
        {
          name: "计费状态",
          type: "select",
          code: "state",
          data: ChargeStateOptions,
        },
        {
          name: "住院号/病历号",
          type: "input",
          code: "patientNo",
        },
        {
          name: "计费单号",
          type: "input",
          code: "chargeNo",
        },
        {
          name: "计费护士",
          type: "input",
          code: "userName",
        },
        {
          name: "患者",
          type: "input",
          code: "patientName",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "计费时间",
          type: "datetimerange",
          format:'yyyy-MM-dd HH:mm:ss',
          code: "date",
        },
        {
          name: "追溯码",
          type: "input",
          code: "traceNo",
        }
      ],
      remarkVisible: false,
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      GetHisCharges(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 打印
    print (command) {
      this.query.type = command;
      GetHisChargePrintData(this.query).then((res) => {
        var result = res.returnData;

        var printData = this.printDataConvert(result.printData);
        this.sendPrintMessage(JSON.stringify(printData));
      });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "编辑";
    },
    
    // 退费
    handleRefunds(row) {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
      this.form = {
        amount: row.amount,
        auxiliaryUnit: row.auxiliaryUnit,
        batch: row.batch,
        category: 1, // 退费固定为1
        categoryName: "退费",
        chargeNo: row.chargeNo + 'T',
        conversionRatio: row.conversionRatio,
        createdDept: row.createdDept,
        chargeDeptName: row.createdDeptName,
        createdTime: row.createdTime,
        createdUser: row.createdUser,
        createdUserName: row.createdUserName,
        createdWard: row.createdWard,
        deptId: row.deptId,
        deptName: row.deptName,
        failureNumber: row.failureNumber,
        hisProjectNo: row.hisProjectNo,
        // id: 0, // 新建时 id 应该自动创建
        isOutpatient: row.isOutpatient,
        mainNo: row.mainNo,
        medicalInsuranceCategoryNo: row.medicalInsuranceCategoryNo,
        number: row.number,
        outPatientState: row.outPatientState,
        patientName: row.patientName,  
        patientNo: row.patientNo,
        price: row.price,
        productName: row.productName,
        receivedTime: row.receivedTime,
        remark: row.remark,
        sourceChargeNo: row.chargeNo, // 原计费单号
        specName: row.specName,
        state: row.state,
        stateName: row.stateName,
        supplierProductId: row.supplierProductId,
        supplierProductName: row.productName, // 使用 productName 作为 supplierProductName
        supplierProductNo: row.supplierProductNo,
        traceNo: row.traceNo,
        wardId: row.wardId,
        orgCode:sessionStorage.getItem('orgId'),
      };
    },

    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveHisCharge(this.form)
          .then((res) => {
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally((res) => { });
      });
    },
    resetForm () {
      const defaultStartDate = this.parseTime(
        new Date(new Date().getFullYear(), new Date().getMonth()-1, new Date().getDate()), 
        "{y}-{m}-{d} {h}:{i}:{s}"
      );
      const defaultEndDate = this.parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}");
      this.form = {
        id: 0,
        supplierProductId: "",
        supplierProductName: "",
        chargeNo: "",
        isOutpatient: 0,
        category: 0,
        deptId: "",
        date: [defaultStartDate, defaultEndDate],
        startDate: defaultStartDate,
        endDateCode: defaultEndDate,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemovePatient({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.loading = true;
      this.getData();
    },

    supplierProductChange (row) {
      console.log(row);
      
      // var arr = this.productList.filter(e => e.id == val)
      this.form.supplierProductId = row.id;
      this.form.supplierProductName = row.productName;
    },

    // 备注
    showRemarkDialog (row) {
      this.isAdd = false;
      this.form = JSON.parse(JSON.stringify(row));

      this.remarkVisible = true;
    },
    saveRemark () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          UpdateHisChargeRemark(this.form).then((res) => {
            this.remarkVisible = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          });
        }
      });
    },

    handleCharge (row) {
      this.$axios
        .get(`${config.ChargeServerHost}/Charge/Charge?id=${row.id}`)
        .then((res) => {
          // this.open = false;
          this.$my_message(`执行成功`, "success");
          this.getData();
        });
    },
    UpdateChargeState () {
      const length = this.multipleSelection.length;
      if (length === 0) {
        this.$my_message("请选择数据", "warning");
        return;
      }

      var ids = [];
      for (let i = 0; i < length; i++) {
        ids.push(this.multipleSelection[i].id);
      }

      UpdateChargeState({ ids: ids }).then((res) => {
        this.handleSelectionChange([]);
        this.$refs.multipleTable.clearSelection();
        this.getData();
      });
    },

    getProductList (keyWord) {
      // query.pageIndex = 1
      // query.pageSize = 100
      // query.status = 2

      this.getSupplierProducts(
        //query)
        {
          keyWord: keyWord,
          pageIndex: 1,
          pageSize: 100,
          status: 2,
        }
      );
    },
    applyDeptChange1(val){
      let arr = this.STATIC_DeptAndWards.filter(res=>res.idGroup == val)
      this.form.deptId = arr[0].hisDeptId
      this.form.wardId = arr[0].hisWardId?arr[0].hisWardId:''
      this.form.deptName =  (arr[0].warehouseName?arr[0].warehouseName:'')+''+ arr[0].deptName + " " + (arr[0].wardName?arr[0].wardName:'');
   
    },
    chargeDeptChange1 (val) {
      let arr = this.STATIC_DeptAndWards.filter(res=>res.idGroup == val)
      this.form.createdDept = arr[0].hisDeptId
      this.form.createWard = arr[0].hisWardId?arr[0].hisWardId:''
      this.form.chargeDeptName =  (arr[0].warehouseName?arr[0].warehouseName:'')+ arr[0].deptName + " " + (arr[0].wardName?arr[0].wardName:'');

    },
    chargeDeptChange (val) {
      this.form.chargeDeptId = val;
    },
    deptChange (val) {
      this.form.deptId = val;
    },
    getDeptList (keyWord) {
      return new Promise((resolve, reject) => {
        this.getDepts(keyWord).then((response) => {
          if (response) {
            response.map((i) => {
              i.id = i.hisDeptId;
              return i;
            });
            resolve(response);
          } else {
            reject(response);
          }
        });
      });
    },
  },
  mounted () {

    if (this.system_setting.IsUseWard) {
      this.getDeptAndWards()

    } else {
      this.getDepts("");
    }
    let date = [
    this.parseTime(new Date(new Date().getFullYear(),new Date().getMonth()-1,new Date().getDate()), "{y}-{m}-{d} {h}:{i}:{s}"),this.parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}") 
    ]
    this.$set(this.query,'date',date)
    this.query.startDate = this.query.date[0]
    this.query.endDateCode = this.query.date[1]
    this.getData();
    this.getUsers("");
  },
};
</script>

<style lang="scss" scoped></style>
